// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ActionType } from 'api/volops';

export const ACTION_TYPE_PLURAL: Array<{
  id: ActionType | 'NONE';
  name: string;
}> = [
  {
    id: 'NONE',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('All'),
  },
  {
    id: 'VOLOP',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Volunteering'),
  },
  {
    id: 'EVENT',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Events'),
  },
  {
    id: 'LOAN',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Loans'),
  },
  {
    id: 'DONATION',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Donations'),
  },
  {
    id: 'PETITION',
    name:
      /* TRANSLATORS: Volunteer +" type */
      getText('Petitions'),
  },
];
